// Maintenance phase. docs/fe-state-machine.md#maintenance.
// Terminal screen — no transitions out. User must reload.

import type { Phase } from "../state/types";
import { mount, clearChildren } from "../ui/overlay";

let cleanup: (() => void) | null = null;

export const Maintenance: Phase = {
  enter() {
    const root = document.getElementById("app")!;
    clearChildren(root);

    const panel = document.createElement("div");
    panel.style.cssText =
      "position:absolute;inset:0;display:flex;align-items:center;justify-content:center;text-align:center;padding:24px;";
    panel.textContent = "Hệ thống đang bảo trì, vui lòng thử lại sau.";
    cleanup = mount(root, panel);
  },
  exit() {
    cleanup?.();
    cleanup = null;
  },
};
